module.exports = __webpack_public_path__ + "img/horses_retail.8b0c801d.png";